/**
 * Emit hosts for the `notes` analytics group — 2 functions
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { getDemoModeForSession } from '@/features/demo-flow/utils/getDemoModeForSession';
import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  type NoteRevertedEventProps,
  type NoteUpdateSource,
  type NoteUpdateType,
} from '@/models/analytics/features/notes';
import { type VoiceStyle } from '@heidi/schema/ml-scribe';

export function trackNoteReverted(input: NoteRevertedEventProps) {
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.NoteReverted,
    props: input,
  });
}

export function trackNoteUpdated(input: {
  session_id: string;
  template_id?: string | null;
  voice_style?: VoiceStyle | null;
  original_word_length?: number | null;
  current_word_length?: number | null;
  word_diff?: number | null;
  edit_rate?: number | null;
  /** Source of the note update: 'user' for manual edits, 'evidence' for Evidence chat content */
  source?: NoteUpdateSource;
  /** Type of update when source is 'evidence': 'add' for appending, 'replace' for replacing */
  update_type?: NoteUpdateType;
}) {
  track({
    options: { amplitude: false },
    event_name: TrackingEventName.NoteUpdated,
    props: {
      ...input,
      // tag note_updated when the user edits the demo's note.
      demo_mode: getDemoModeForSession(input.session_id),
    },
  });
}
